import { Tabs } from '@/ui-kit'
import { useState } from 'react'
import { useStakingRewardsConfig } from '../../api/useStakingRewardsConfig'
import { useValidatorAPYContext } from '../../providers/ValidatorAPYContext'

type ProjectedEarningsProps = {
  stakeAmount: string
}

type EarningsPeriod = '3month' | '6month' | 'year'

const PERIOD_FACTOR: Record<EarningsPeriod, number> = {
  '3month': 3 / 12,
  '6month': 6 / 12,
  year: 1
}

const EARNINGS_TABS = [
  { value: '3month' as const, title: '3 months' },
  { value: '6month' as const, title: '6 months' },
  { value: 'year' as const, title: 'Yearly' }
]

export const ProjectedEarnings = ({ stakeAmount }: ProjectedEarningsProps) => {
  const [period, setPeriod] = useState<EarningsPeriod>('year')
  const { apy } = useValidatorAPYContext()
  const { base, rate, isLoading: isConfigLoading, minStakeSol } = useStakingRewardsConfig()
  const amount = Number.parseFloat(stakeAmount) || 0
  const yearlyRewards = amount > 0 ? (amount * apy) / 100 : 0
  const yearlyAirdrops = amount > 0 ? (amount * rate + base) * 182 : 0
  const factor = PERIOD_FACTOR[period]
  const projectedRewards = yearlyRewards * factor
  const projectedAirdrops = yearlyAirdrops * factor

  const periodLabel = EARNINGS_TABS.find((tab) => tab.value === period)?.title

  return (
    <div className="flex flex-col">
      <div className="mb-3 max-w-max max-mobile:max-w-full">
        <Tabs<{ value: EarningsPeriod; title: string }>
          className="h-10"
          size="small"
          tabs={EARNINGS_TABS}
          value={period}
          onChange={(tab) => setPeriod(tab.value)}
        />
      </div>
      <div className="flex flex-col justify-between gap-2 py-3">
        <span className="text-body-3 text-gray-90">{periodLabel} Projected Rewards</span>
        <span className="font-semibold">
          {amount > 0 ? (projectedRewards < 0.01 ? '<0.01' : projectedRewards.toFixed(2)) : '0'} SOL
        </span>
      </div>
      <div className="flex flex-col justify-between gap-2 border-t border-gray-100 py-3">
        <span className="text-body-3 text-gray-90">{periodLabel} Projected Airdrops Points</span>
        <span className="font-semibold">
          {amount === 0 || amount < minStakeSol
            ? '0'
            : isConfigLoading
              ? '-'
              : projectedAirdrops.toLocaleString('en-US', { maximumFractionDigits: 0, minimumFractionDigits: 0 })}{' '}
          $DATA Points
        </span>
      </div>
    </div>
  )
}
